export default __webpack_public_path__ + "static/media/folder-favorite 1.c3d392fc.svg";